/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type PaymentMethod =
  | 'STRIPE'
  | 'UNKNOWN';

/** 渡されないプロパティは更新されない */
export type UpdateContractInput = {
  email?: string | null | undefined;
  invoiceCustomerName?: string | null | undefined;
};

export type UpdateContractMutationVariables = Exact<{
  input: Types.UpdateContractInput;
}>;


export type UpdateContractMutation = { updateContract: { id: string, invoiceCustomerName: string, email: string, paymentMethod: Types.PaymentMethod } };

export type GenerateStripeCreditCardSavingUrlMutationVariables = Exact<{
  successCallbackUrl: string;
  cancelCallbackUrl: string;
}>;


export type GenerateStripeCreditCardSavingUrlMutation = { generateStripeCreditCardSavingUrl: string };


export const UpdateContractDocument = gql`
    mutation updateContract($input: UpdateContractInput!) {
  updateContract(input: $input) {
    id
    invoiceCustomerName
    email
    paymentMethod
  }
}
    `;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateContractMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractMutation(options: VueApolloComposable.UseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateContractMutation, UpdateContractMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateContractMutation, UpdateContractMutationVariables>(UpdateContractDocument, options);
}
export type UpdateContractMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateContractMutation, UpdateContractMutationVariables>;
export const GenerateStripeCreditCardSavingUrlDocument = gql`
    mutation generateStripeCreditCardSavingUrl($successCallbackUrl: String!, $cancelCallbackUrl: String!) {
  generateStripeCreditCardSavingUrl(
    successCallbackUrl: $successCallbackUrl
    cancelCallbackUrl: $cancelCallbackUrl
  )
}
    `;

/**
 * __useGenerateStripeCreditCardSavingUrlMutation__
 *
 * To run a mutation, you first call `useGenerateStripeCreditCardSavingUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useGenerateStripeCreditCardSavingUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useGenerateStripeCreditCardSavingUrlMutation({
 *   variables: {
 *     successCallbackUrl: // value for 'successCallbackUrl'
 *     cancelCallbackUrl: // value for 'cancelCallbackUrl'
 *   },
 * });
 */
export function useGenerateStripeCreditCardSavingUrlMutation(options: VueApolloComposable.UseMutationOptions<GenerateStripeCreditCardSavingUrlMutation, GenerateStripeCreditCardSavingUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<GenerateStripeCreditCardSavingUrlMutation, GenerateStripeCreditCardSavingUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<GenerateStripeCreditCardSavingUrlMutation, GenerateStripeCreditCardSavingUrlMutationVariables>(GenerateStripeCreditCardSavingUrlDocument, options);
}
export type GenerateStripeCreditCardSavingUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<GenerateStripeCreditCardSavingUrlMutation, GenerateStripeCreditCardSavingUrlMutationVariables>;